<template>
  <div class="view-container">
    <sidebar />
    <div
      class="app-container"
      @click="$eventHub.$emit('hide-search', $event)"
    >
      <main-header />
      <div class="content">
        <div class="container">
          <div class="row">
            <div class="col-8 col-xs-12 content-inner">
              <impressions
                :data="impressions.data"
                :current-date="impressions.date"
                :period="impressions.period"
                @change-date="changeImpressionsDate"
                @change-period="changeImpressionsPeriod"
              />
            </div>
            <div class="col-4 col-xs-12 content-inner">
              <dashboard-widget
                title="Top spending company"
                :subtitle="topSpendingCompany?.company?.name || '-'"
                :logo="topSpendingCompany?.company?.logo || null"
              >
                <dashboard-widget-stat
                  v-if="topSpendingCompany?.impressions"
                  title="Impressions"
                  :value="
                    Utils.parseImpressionCount(
                      topSpendingCompany.impressions
                    )
                  "
                />
              </dashboard-widget>
            </div>
          </div>
          <div class="row">
            <div class="col-8 col-xs-12 content-inner">
              <user-activity
                :data="userActivity.data"
                :current-date="userActivity.date"
                :period="userActivity.period"
                @change-date="changeActivityDate"
                @change-period="changeActivityPeriod"
              />
            </div>
            <div class="col-4 col-xs-12 content-inner">
              <dashboard-widget
                title="Most active company"
                :subtitle="mostActiveCompany.data.company?.name || '-'"
                :logo="mostActiveCompany.data.company?.logo || null"
              >
                <dashboard-widget-stat
                  v-if="mostActiveCompany.data.creatives"
                  title="Creatives"
                  :value="
                    Utils.parseImpressionCount(mostActiveCompany.data.creatives)
                  "
                />
                <dashboard-widget-stat
                  v-if="mostActiveCompany.data.campaigns"
                  title="Campaigns"
                  :value="
                    Utils.parseImpressionCount(mostActiveCompany.data.campaigns)
                  "
                />
                <dashboard-widget-stat
                  v-if="mostActiveCompany.data.impressions"
                  title="Impressions"
                  :value="
                    Utils.parseImpressionCount(
                      mostActiveCompany.data.impressions
                    )
                  "
                />
              </dashboard-widget>
            </div>
          </div>
        </div>
        <loading-status />
      </div>
    </div>
  </div>
</template>
<script>
import Impressions from "@/components/super_admin_dashboard/Impressions.vue"
import DashboardWidget from "@/components/super_admin_dashboard/DashboardWidget.vue"
import DashboardWidgetStat from "@/components/super_admin_dashboard/DashboardWidgetStat.vue"
import UserActivity from "@/components/super_admin_dashboard/UserActivity.vue"
import { mapState, mapActions } from "vuex"
import Utils from "@/utils"
import { SuperAdminDashboardRoutes } from "@/api/routes"
import dayjs from "dayjs"
import { REPORTING_PERIOD_MONTHLY } from "@/constants"

export default {
  components: {
    Impressions,
    UserActivity,
    DashboardWidget,
    DashboardWidgetStat
  },
  data () {
    return {
      impressions: {
        data: [],
        date: dayjs(),
        period: REPORTING_PERIOD_MONTHLY
      },
      userActivity: {
        data: [],
        date: dayjs(),
        period: REPORTING_PERIOD_MONTHLY
      },
      mostActiveCompany: {
        data: {}
      }
    }
  },
  computed: {
    ...mapState(["currentUser"]),
    topSpendingCompany () {
      return this.impressions.data[0] || null
    },
    Utils () {
      return Utils
    }
  },
  watch: {
    currentUser: {
      immediate: true,
      handler () {
        this.checkSuperAdminAccess()
      }
    }
  },
  mounted () {
    this.fetchImpressionData()
    this.fetchUserActivity()
  },
  methods: {
    ...mapActions(["loadCurrentUser"]),
    async checkSuperAdminAccess () {
      try {
        if (!this.currentUser) {
          const currentUser = await this.loadCurrentUser()
          if (!this.isSuperAdmin(currentUser)) {
            this.redirectToHome()
          }
        } else if (!this.isSuperAdmin(this.currentUser)) {
          this.redirectToHome()
        }
      } catch (error) {
        console.error("Failed to check super admin access:", error)
        this.redirectToLogin()
      }
    },
    isSuperAdmin (user) {
      return user?.roles?.super_admin === true
    },
    redirectToHome () {
      this.$router.push({ name: "home" })
    },
    redirectToLogin () {
      this.$router.push({ name: "login" })
    },
    fetchImpressionData () {
      if (this.impressions.date && this.impressions.period) {
        const p1 = this.$apiClient.get(SuperAdminDashboardRoutes.impressions(), {
          params: {
            start: this.impressions.date.format("YYYY-MM-DD"),
            period: this.impressions.period
          }
        }).then((resp) => {
          this.impressions.data = resp.data.data
        })

        const p2 = this.$apiClient.get(SuperAdminDashboardRoutes.mostActive(), {
          params: {
            start: this.impressions.date.format("YYYY-MM-DD"),
            period: this.impressions.period
          }
        }).then((resp) => {
          this.mostActiveCompany.data = resp.data.data
        })

        return Promise.all([p1, p2])
      }
    },
    fetchUserActivity () {
      if (this.userActivity.date && this.userActivity.period) {
        return this.$apiClient.get(SuperAdminDashboardRoutes.activity(), {
          params: {
            start: this.userActivity.date.format("YYYY-MM-DD"),
            period: this.userActivity.period
          }
        }).then((resp) => {
          this.userActivity.data = resp.data.data
        })
      }
    },
    changeImpressionsDate (newDate) {
      this.impressions.date = newDate
      this.fetchImpressionData()
    },
    changeImpressionsPeriod (newPeriod) {
      this.impressions.period = newPeriod
      this.fetchImpressionData()
    },
    changeActivityDate (newDate) {
      this.userActivity.date = newDate
      this.fetchUserActivity()
    },
    changeActivityPeriod (newPeriod) {
      this.userActivity.period = newPeriod
      this.fetchUserActivity()
    }
  }
}
</script>
